module.exports = __webpack_public_path__ + "media/images/icons/SVG/009-4509b8e69ac0b3be481cf9776207f1e2.svg";